<template>
  <div>
    <hero />

    <v-container
      class="py-5 px-0"
      fluid
    >
      <who-i-am />

      <where-ive-been />

      <what-ive-done />

      <lets-talk />
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      Hero: () => import('@/views/Hero'),
      WhoIAm: () => import('@/views/WhoIAm'),
      WhereIveBeen: () => import('@/views/WhereIveBeen'),
      WhatIveDone: () => import('@/views/WhatIveDone'),
      LetsTalk: () => import('@/views/LetsTalk'),
    },

    metaInfo () {
      return {
        title: this.$i18n.t('Home.title'),
      }
    },

    data: () => ({
      //
    }),
  }
</script>
